/**
 * External dependencies
 */
import "@micropackage/vw/src/js/vw.js";
import objectFitImages from "object-fit-images";
import responsiveEmbeds from "@micropackage/responsive-embeds";
import "./blocks";
import menu from "./sections/menu";
import SelectButton from "./components/select-btn";
import Footer from "./sections/footer";

/**
 * Internal dependencies
 */
import "../images/arrow-right.svg";

objectFitImages();
responsiveEmbeds('iframe[src*="youtube.com"], iframe[src*="vimeo.com"]');

menu();

for (const selectBtn of document.querySelectorAll(".subscribe-button")) {
	new SelectButton(selectBtn);
}

new Footer();
